import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { cn } from "@/lib/utils";
import { Home, Briefcase, User, LogOut, Sun, Moon, Radar } from "lucide-react";

const TABS = [
  { to: "/engineer",         label: "Jobs",    icon: Briefcase },
  { to: "/engineer/history", label: "History", icon: Home },
  { to: "/engineer/profile", label: "Me",      icon: User },
];

export default function EngineerLayout() {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex h-screen flex-col bg-background">
      <header className="flex items-center justify-between border-b border-border/60 bg-card/50 px-4 py-3 backdrop-blur">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <Radar className="h-4 w-4" />
          </div>
          <div>
            <p className="font-heading text-sm font-bold leading-none">HCIT-CallCRM</p>
            <p className="mt-1 text-[10px] uppercase tracking-widest text-muted-foreground">Engineer · {user?.name}</p>
          </div>
        </div>
        <div className="flex gap-1">
          <button data-testid="theme-toggle-engineer" onClick={toggle} className="rounded-md border border-border/70 p-2 text-muted-foreground">
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>
          <button data-testid="logout-engineer" onClick={handleLogout} className="rounded-md border border-border/70 p-2 text-muted-foreground">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      <nav className="fixed inset-x-0 bottom-0 border-t border-border/60 bg-card/95 backdrop-blur">
        <div className="mx-auto grid max-w-lg grid-cols-3">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === "/engineer"}
              data-testid={`engineer-tab-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center gap-1 py-3 text-xs font-medium transition-colors",
                  isActive ? "text-primary" : "text-muted-foreground",
                )
              }
            >
              <t.icon className="h-5 w-5" />
              {t.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
